import { Navigate, Route, RouteProps } from "react-router";
import { useAuth } from "../../auth/contexts/AuthProvider";
import { getUser } from "../../admin/infra/getUser";

type PrivateRouteProps = {
  roles?: string[];
} & RouteProps;

const PrivateRoute = ({
  children,
  roles,
  ...routeProps
}: PrivateRouteProps) => {
  const { hasRole, userInfo } = useAuth();

  if (userInfo) {
    if (!hasRole(roles)) {
      return <Navigate to={`/${process.env.PUBLIC_URL}/403`} />;
    }
    if (getUser().cf === "null") {
      if (
        window.location.href.includes("/cadastro") &&
        getUser().cf === "null"
      ) {
        return <Route {...routeProps} />;
      } else {
        return <Navigate to={`/${process.env.PUBLIC_URL}/cadastro`} />;
      }
    }
    return <Route {...routeProps} />;
  } else {
    return <Navigate to={`/${process.env.PUBLIC_URL}/login`} />;
  }
};

export default PrivateRoute;
